import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import {
  InfoCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Col, Row, Table, Typography } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import usePremisions from '../usePremisions';
import DeleteModal from 'components/deleteModalView';
import EditModal from '../edit';
import { DeleteIcon } from '../../../../../../icons';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../../hooks/useUser';

const CompanyCategoriesMainPage = () => {
  const { t } = useTranslation();

  const {
    columns,
    data,
    loading,
    updateInProcess,
    onChangeTableFilter,
    handleDeleteCategory,
    form,
    premisionsGroups,
    handleCreateRole,
    onDelete,
  } = usePremisions(true);
  const pages = useRecoilValue(getPage);
  return (
    <div>
      <div className={styles.container}>
        {!!data?.permission_groups?.length && pages?.ability?.can_create && (
          <Table
            columns={columns}
            dataSource={data.permission_groups}
            pagination={data.pagination}
            onChange={onChangeTableFilter}
            loading={loading}
          />
        )}
        {!data?.permission_groups?.length && (
          <Row className={styles.emptyRow} justify={'center'}>
            <div className={styles.actionIcon}>
              <SearchOutlined />
            </div>
            <Typography.Title level={4}>
              {t('Mentre non ci sono diritti')}
            </Typography.Title>
            <Typography className={styles.textNew} color='red'>
              {t('Creane uno nuovo')}
            </Typography>
            <Link to={'create/new'}>
              <Button width={'191px'} big icon={<PlusOutlined />}>
                {t('Crea un nuovo')}
              </Button>
            </Link>
          </Row>
        )}
      </div>
      <Routes>
        <Route
          path={'new'}
          element={
            <EditModal
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsGroups={premisionsGroups}
              handleCreateRole={handleCreateRole}
            />
          }
        />
        <Route
          path={'edit'}
          element={
            <EditModal
              isEdit
              form={form}
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
              premisionsGroups={premisionsGroups}
              handleCreateRole={handleCreateRole}
            />
          }
        />
        <Route
          path={'delete'}
          element={
            <DeleteModal onClickDelete={onDelete} loading={updateInProcess} />
          }
        />
      </Routes>
    </div>
  );
};

export default CompanyCategoriesMainPage;
